import React from 'react';
import { ChevronRight, MoreVertical } from 'lucide-react';

const DotsMenu = ({ 
  id, 
  type, 
  goalId = null, 
  stepId = null, 
  taskId = null,
  openMenuId,
  setOpenMenuId,
  openSubmenuId,
  setOpenSubmenuId,
  deleteGoal,
  deleteStep,
  deleteTask,
  deleteInitiative,
  setGoalPriority,
  setStepPriority,
  setTaskPriority,
  setInitiativePriority
}) => {
  const isOpen = openMenuId === id;
  const isSubMenuOpen = openSubmenuId === id;
  
  const handleDelete = () => {
    if (type === 'goal' && deleteGoal) {
      deleteGoal(id);
    } else if (type === 'step' && deleteStep) {
      deleteStep(id);
    } else if (type === 'task' && deleteTask) {
      deleteTask(id);
    } else if (type === 'initiative' && deleteInitiative) {
      deleteInitiative(id);
    }
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };

  const handleSetPriority = (priority) => {
    if (type === 'goal' && setGoalPriority) {
      setGoalPriority(id, priority);
    } else if (type === 'step' && setStepPriority) {
      setStepPriority(id, priority);
    } else if (type === 'task' && setTaskPriority) {
      setTaskPriority(id, priority);
    } else if (type === 'initiative' && setInitiativePriority) {
      setInitiativePriority(id, priority);
    }
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };
  
  return (
    <div 
      className="menu-container relative mt-1"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="text-gray-400 hover:text-gray-600 p-1"
        onClick={(e) => {
          e.stopPropagation();
          setOpenMenuId(isOpen ? null : id);
          if (!isOpen) {
            setOpenSubmenuId(null);
          }
        }}
      >
        <MoreVertical size={16} />
      </button>
      
      {isOpen && (
        <div className="absolute right-0 mt-1 bg-white shadow-lg rounded-md z-50 w-32 py-1 border">
          <button
            className="w-full text-left px-3 py-1 hover:bg-gray-100"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
          >
            Delete
          </button>
          
          <button
            className="w-full text-left px-3 py-1 hover:bg-gray-100 flex justify-between items-center"
            onClick={(e) => {
              e.stopPropagation();
              setOpenSubmenuId(isSubMenuOpen ? null : id);
            }}
          >
            <span>Set Priority</span>
            <ChevronRight size={14} />
          </button>
          
          {isSubMenuOpen && (
            <div className="absolute right-full top-0 bg-white shadow-lg rounded-md z-50 w-28 py-1 border">
              <button
                className="w-full text-left px-3 py-1 hover:bg-yellow-100"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSetPriority('high');
                }}
              >
                High
              </button>
              <button
                className="w-full text-left px-3 py-1 hover:bg-orange-100"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSetPriority('medium');
                }}
              >
                Medium
              </button>
              <button
                className="w-full text-left px-3 py-1 hover:bg-blue-100"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSetPriority('low');
                }}
              >
                Low
              </button>
              <button
                className="w-full text-left px-3 py-1 hover:bg-grey-100"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSetPriority(null);
                }}
              >
                None
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DotsMenu; 